import { createSelector } from '@reduxjs/toolkit';
import { EGarageStatus } from '../../../../packages/JsonQuery';
import { selectGarageStatus } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Собственность', value: EGarageStatus.Ownership },
  { label: 'Кооператив', value: EGarageStatus.Cooperative },
  { label: 'По договорённости', value: EGarageStatus.Agreement },
];

export const selectGarageStatusFilter = createSelector(selectGarageStatus, value => ({
  label: 'Статус',
  value: value?.length ? (value as EGarageStatus[]) : [null],
  options: OPTIONS,
}));
